import styled from 'styled-components';
import { RIGHT_COLUMN_WIDTH } from 'styleguide';

const AuditListWrapper = styled.div`
  padding-top: 15px;
  flex-shrink: 1;
  flex-basis: calc(100% - ${RIGHT_COLUMN_WIDTH});
`;

export default AuditListWrapper;
